// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"246652c9","190":"1abaa1bc","443":"c4c66b0b","878":"9909f4a9","931":"7faf0f78"}[chunkId] + ".css";
};